<template>
    <v-container>
        <v-form ref="form" lazy-validation>
            <v-row>
                <v-col cols="12">
                    <v-text-field
                        label="Booked Off Cause"
                        v-model="cause"
                        :rules="[v => !!v || 'Book Off Cause is required']"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-col cols="1" class="mr-5">
                    <v-btn color="success" @click="save">Save</v-btn>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>
<script>
import axios from 'axios';
export default {
    props: ['id'],
    data: function() {
        return {
            dialog: false,
            cause: ''
        };
    },
    mounted() {
        this.loadBookOffCause();
    },
    watch: {
        id: function() {
            if (this.id == 0) {
                this.cause = '';
            } else {
                this.loadBookOffCause();
            }
        }
    },
    methods: {
        loadBookOffCause: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .get('bookedoff-cause/' + this.id)
                .then(response => {
                    var dt = response.data;
                    this.cause = dt[0].BookedCauseDescription;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        newBookOffCause: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            var pars = {
                BookedCauseDescription: this.cause,
                Active: 1
            };
            console.log(pars);
            axios
                .post('bookedoff-cause', pars)
                .then(response => {
                    var dt = response.data;
                    console.log(dt);
                    this.$store.state.bannerType = true;
                    str.dispatch('setSnackbar', {
                        color: 'indigo',
                        text: 'Book Off Cause added successfully'
                    });
                    this.$store.state.book.dialog = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },

        editBookOffCause: function() {
            var str = this.$store;
            var pars = {
                BookedCauseDescription: this.cause,
                Active: 1
            };
            axios
                .put('bookedoff-cause/' + this.id, pars)
                .then(response => {
                    var dt = response.data;
                    console.log(dt);
                    this.$store.state.bannerType = true;
                    str.dispatch('setSnackbar', {
                        color: 'indigo',
                        text: 'Book Off Cause Type changed.'
                    });
                    this.$store.state.book.dialog = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
        },

        save: function() {
            if (this.id == 0) {
                if (this.$refs.form.validate()) {
                    this.newBookOffCause();
                }
            } else {
                if (this.$refs.form.validate()) {
                    this.editBookOffCause();
                }
            }
        }
    }
};
</script>
